import { DatasetRequest } from "@/types/app/dataset";

export const DEFAULT_DATASET: Omit<DatasetRequest, "commit_message" | "version_name" | "version_description"> = {
  datapoints: [],
  action: "set",
};
